import { IQuoteState } from '@/store/quote';
import { IQuoteGetters } from './getters.types';
import {
  IQuote,
  IQuoteData,
  IQuotePackage,
  Quote,
  QuotePackage
} from '@/models';

export const getters: IQuoteGetters = {
  getQuotes(state: IQuoteState): IQuote[] {
    return state.quotes.map(data => new Quote(data));
  },

  getQuoteCount(state: IQuoteState): number {
    return state.count;
  },

  getQuoteById: (state: IQuoteState) => (id: number): IQuote | undefined => {
    const data = state.quotes.find(quote => quote.number === id);
    if (!data) {
      return undefined;
    }

    return new Quote(data);
  },

  getQuoteByIdAndRevision: (state: IQuoteState) => (
    id: number,
    revision: number
  ): IQuote | undefined => {
    const data = state.quotes.find(
      quote => quote.number === id && quote.revision === revision
    );

    if (!data) {
      return undefined;
    }

    return new Quote(data);
  },

  getQuoteLastAdded(state: IQuoteState): IQuote | undefined {
    if (state.quotes.length > 0) {
      const data = state.quotes[state.quotes.length - 1];
      return new Quote(data);
    }
    return undefined;
  },

  getQuotePackageByQuoteNumberAndRevision: (state: IQuoteState) => (
    quoteNumber: number,
    revision: number
  ): IQuotePackage | undefined => {
    const data = state.quotePackages.find(quotePackage => {
      return quotePackage.quotes?.find(
        quote =>
          quote.number == quoteNumber &&
          quote.package == quotePackage.id &&
          quote.revision == revision
      );
    });

    if (!data) {
      return undefined;
    }

    return new QuotePackage(data);
  },

  getQuotePackageById: (state: IQuoteState) => (
    id: number
  ): IQuotePackage | undefined => {
    const data = state.quotePackages.find(quote => quote.id === id);
    if (!data) {
      return undefined;
    }

    return new QuotePackage(data);
  },

  getQuotePackageLastAdded(state: IQuoteState): QuotePackage | undefined {
    if (state.quotePackages.length > 0) {
      const data = state.quotePackages[state.quotePackages.length - 1];
      return new QuotePackage(data);
    }
    return undefined;
  }
};
